export type AdminChatConfig = {
  // Telegram link to open the admin chat or profile.
  // Examples: https://t.me/<username> or tg://resolve?domain=<username>
  url: string;
};

export const ADMIN_CHAT: AdminChatConfig = {
  url: 'https://t.me/NorthErrant',
};

export const DEVELOPER_CHAT = {
  url: 'https://t.me/BladeSvt',
};
